// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC9yhlldjov8rWNNl0b1sdR1vFnY00c5XM",
  authDomain: "note-app-2bac0.firebaseapp.com",
  projectId: "note-app-2bac0",
  storageBucket: "note-app-2bac0.appspot.com",
  messagingSenderId: "668502599328",
  appId: "1:668502599328:web:0a5e3ddc0725ad260dcbc5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;
